/* eslint-disable no-unused-vars */

class ListMilestone {
  constructor(obj) {
    this.id = obj.id;
    this.title = obj.title;
  }
}

window.ListMilestone = ListMilestone;



// WEBPACK FOOTER //
// ./boards/models/milestone.js